import en from './en'
import th from './th'
import lo from './lo'

export default {
    en,
    th,
    lo
}